import React, { useState } from 'react';
import { Button, Card, Form, Modal } from 'react-bootstrap';
import { Formik } from 'formik';
import { format } from 'date-fns';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import AntDatePicker from '../AntDatePicker';
import styles from './BookSlotModal.module.scss';
import { postCellRequest } from '../../manager/containers/Booking/services/actions';
import TopBorderBtn from '../TopBorderBtn';

type Props = {
  isShow: boolean;
  closeModal: () => void;
  rowCell: any;
  cellDate: any;
  duration: any;
};

const BookSlotModal: React.FC<Props> = ({ isShow, closeModal, rowCell, cellDate, duration }) => {
  const [error, setError] = useState<string>();
  const initValue: any = {
    from: '',
    to: '',
    vertical: '',
    horizontal: '',
    day: '',
  };
  const label = `Заблокувати слот ${rowCell.time} - ${moment(rowCell.time, 'HH:mm')
    .add(duration, 'minutes')
    .format('HH:mm')} щоденно до`;
  const dispatch = useDispatch();

  const blockCellHandler = (values: any) => {
    if (values.horizontal) {
      const splitDate = cellDate.split('.');
      const date = new Date(`${splitDate[2]}, ${splitDate[1]}, ${splitDate[0]}, ${rowCell.time}`);
      const checkOutTime = new Date(date).getMinutes() + +duration;
      const checkOutDate = new Date(date).setMinutes(checkOutTime);
      const checkInDateF = format(date, "yyyy-MM-dd'T'HH:mm:ss");
      const checkOutDateF = format(new Date(checkOutDate), 'HH:mm:ss');
      const fromDateYMD = values.from.format('YYYY-MM-DD');
      const fromDateYMDPlusTime = `${fromDateYMD}T${checkOutDateF}`;
      const fromDateYMDPlusTimeUnix = moment(fromDateYMDPlusTime).unix();
      const twoWeeks = moment(new Date()).add(14, 'days').unix();
      if (fromDateYMDPlusTimeUnix > twoWeeks) {
        setError('Блокування доступно до двох тижнів');
      } else {
        setError('');
        dispatch(postCellRequest(checkInDateF, fromDateYMDPlusTime, true, 0));
        closeModal();
      }
    }
    if (values.vertical) {
      const splitDate = cellDate.split('.');
      const date = new Date(`${splitDate[2]}, ${splitDate[1]}, ${splitDate[0]}, ${rowCell.time}`);
      const checkInDateF = format(date, "yyyy-MM-dd'T'HH:mm:ss");
      const toDateYMD = values.to.format('YYYY-MM-DDTHH:mm:00');
      const toDateYMDUnix = moment(toDateYMD).unix();
      const twoWeeks = moment(new Date()).add(14, 'days').unix();
      if (toDateYMDUnix > twoWeeks) {
        setError('Блокування доступно до двох тижнів');
      } else {
        dispatch(postCellRequest(checkInDateF, toDateYMD, true, 1));
        closeModal();
      }
    }
    if (values.day) {
      const splitDate = cellDate.split('.');
      const date = new Date(`${splitDate[2]}, ${splitDate[1]}, ${splitDate[0]}, ${rowCell.time}`);
      const checkOutTime = new Date(date).getMinutes() + +duration;
      const checkOutDate = new Date(date).setMinutes(checkOutTime);
      const checkInDateF = format(date, "yyyy-MM-dd'T'HH:mm:ss");
      const checkOutDateF = format(new Date(checkOutDate), 'HH:mm:ss');
      const dateYMD = format(date, 'yyyy-MM-dd');
      const dateYMDPlusTime = `${dateYMD}T${checkOutDateF}`;
      const dateYMDPlusTimeUnix = moment(dateYMDPlusTime).unix();
      const twoWeeks = moment(new Date()).add(14, 'days').unix();
      if (dateYMDPlusTimeUnix > twoWeeks) {
        setError('Блокування доступно до двох тижнів');
      } else {
        dispatch(postCellRequest(checkInDateF, dateYMDPlusTime, true, 1));
        closeModal();
      }
    }
  };
  return (
    <Modal dialogClassName={styles.modal} show={isShow}>
      <Formik initialValues={initValue} onSubmit={blockCellHandler}>
        {({ handleSubmit, values, setFieldValue, resetForm }) => (
          <form onSubmit={handleSubmit}>
            <Card>
              <Card.Header className="d-flex flex-row justify-content-between mb-2">
                <div>
                  <h6 className="ml-4">Блокування слотів</h6>
                  <h6 className="ml-4 text-danger">{cellDate}</h6>
                </div>
                <TopBorderBtn icon="close" className={styles.exit} clickHandler={closeModal} />
              </Card.Header>
              <Card.Body>
                {error === '' ? (
                  <span className="mb-2"> </span>
                ) : (
                  <h5 className="text-danger mb-2 text-center">{error}</h5>
                )}
                <div className="d-flex flex-row justify-content-between ml-4 mr-4 mb-5">
                  <Form.Check
                    className={styles.radioBtn}
                    type="radio"
                    name="variant"
                    label="Заблокувати вибраний слот"
                    value={values.variant}
                    onChange={() => {
                      setFieldValue('horizontal', false);
                      setFieldValue('vertical', false);
                      setFieldValue('day', true);
                    }}
                  />
                </div>
                <div className="d-flex flex-row justify-content-between ml-4 mr-4 mb-5">
                  <Form.Check
                    className={styles.radioBtn}
                    type="radio"
                    name="variant"
                    label={label}
                    value={values.variant}
                    onChange={() => {
                      setFieldValue('horizontal', true);
                      setFieldValue('vertical', false);
                      setFieldValue('day', false);
                    }}
                  />
                  <AntDatePicker name="from" format="YYYY-MM-DD" cellDate={cellDate} />
                </div>
                <div className="d-flex flex-row justify-content-between ml-4 mr-4 mb-5">
                  <Form.Check
                    className={styles.radioBtn}
                    type="radio"
                    name="variant"
                    label="Заблокувати всі слоти до"
                    value={values.variant}
                    onChange={() => {
                      setFieldValue('horizontal', false);
                      setFieldValue('vertical', true);
                      setFieldValue('day', false);
                    }}
                  />
                  <AntDatePicker name="to" format="YYYY-MM-DD HH:mm" cellDate={cellDate} />
                </div>
                <div className="d-flex justify-content-around">
                  <Button
                    className="px-5 mr-4"
                    onClick={() => {
                      resetForm();
                      setError('');
                      closeModal();
                    }}
                    variant="outline-danger"
                  >
                    Відмінити
                  </Button>
                  <Button
                    className="px-5"
                    onClick={() => blockCellHandler(values)}
                    disabled={values.vertical && values.horizontal === ''}
                    variant="outline-secondary"
                  >
                    Зберегти
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </form>
        )}
      </Formik>
    </Modal>
  );
};

export default BookSlotModal;
